import { render, staticRenderFns } from "./PaginaAsignacionInformadoresMunicipalidad.vue?vue&type=template&id=754fdbce&lang=es"
import script from "./PaginaAsignacionInformadoresMunicipalidad.vue?vue&type=script&lang=js"
export * from "./PaginaAsignacionInformadoresMunicipalidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports